<template>
	<v-card-text>
		<v-row v-if="step.substeps">
			<substeps :substeps="step.substeps" />
		</v-row>
		<v-row v-else>
			<step :step="step" />
		</v-row>
		<template v-if="showUnpair">
			<v-row v-if="!unpairing && !success" class="mt-5">
				<v-col cols="8" sm="9">
					If your echo was previously associated with another room, click
					"Unpair"
				</v-col>
				<v-col cols="4" sm="3">
					<v-btn text color="primary" @click="doUnpair">Unpair</v-btn>
				</v-col>
			</v-row>
			<v-row v-else-if="success" class="mt-5">
				<v-col cols="8" sm="9"
					>Device is now unpaired! Click next to continue...</v-col
				>
			</v-row>
			<v-row v-else class="mt-5">
				<v-progress-linear indeterminate />
				<v-col cols="12">
					<!-- eslint-disable-next-line vue/no-v-html -->
					<span v-html="unpairText" />
				</v-col>
			</v-row>
		</template>
	</v-card-text>
</template>

<script>
import _ from "lodash";
import { mapActions } from "vuex";

import cloud from "@/api/cloud";

import Substeps from "../Substeps";
import Step from "../Step";
import stepBase from "../../extends/step";

export default {
	components: {
		Substeps,
		Step,
	},

	mixins: [stepBase],

	props: {
		step: Object,
		unpair: Object,
	},

	data() {
		return {
			success: false,
			unpairing: false,
			stepNumber: 1,
		};
	},

	computed: {
		dsn() {
			return _.get(this.device, "properties.dsn.value");
		},

		showUnpair() {
			return !_.isEmpty(this.dsn);
		},

		unpairText() {
			const customMessage = _.get(this, "unpair.text");
			const defaultMessage =
				"Waiting to unpair. Follow your devices instructions to finish removing from network...";
			return customMessage || defaultMessage;
		},
	},

	methods: {
		...mapActions({ setNodeProperty: "controller/nodes/setProperty" }),

		async doUnpair() {
			if (this.busy) {
				return;
			}
			this.setBusy(true);

			try {
				this.unpairing = true;

				this.$log(
					`Alexa Wizard: Starting unpair ${this.device.path} with DSN ${this.dsn}`
				);

				await cloud.detachA4HDevice(this.dsn);
			} catch (e) {
				return this.handleError(e);
			} finally {
				this.unpairing = false;
			}

			try {
				await this.setNodeProperty({
					nodeGuid: this.device.meta ? this.device.meta.guid : this.device.guid,
					propName: "dsn",
					propValue: null,
				});
				this.success = true;
				this.$log(`Alexa Wizard: Device detached ${this.device.path}`);
			} catch (e) {
				return this.handleError(e);
			}

			this.setBusy(false);
		},

		handleError(e) {
			let errorMessage = e;
			if (_.isError(e)) errorMessage = e.message;
			else if (_.isObject(e)) errorMessage = JSON.stringify(e);

			this.$log(
				`Alexa Wizard: Unpair failed for ${this.device.path} with error ${errorMessage}`
			);
			return this.showError("Unpair failed. Please try again.");
		},
	},
};
</script>
